import buildProviders from "../screens/helpers/provider-list";

const filterProviders = (providerList, filters, previousProviders) => {
  let filteredProviders = previousProviders.length
    ? providerList
        .map(provider => {
          if (
            previousProviders.find(
              prv =>
                prv.cellData.searchableTerm === provider.cellData.searchableTerm
            )
          ) {
            provider.cellData.notAcceptingNewPatients = false;
          }
          return provider;
        })
        .filter(provider => !provider.cellData.notAcceptingNewPatients)
    : providerList.filter(provider => {
        return (
          !provider.cellData.notAcceptingNewPatients ||
          !provider.cellData.hasOwnProperty("notAcceptingNewPatients")
        );
      });
  if (
    !filters.hasOwnProperty("can_prescribe") ||
    (!filters.gender.length &&
      !filters.languages.length &&
      !filters.provider_specialties.length &&
      !filters.can_prescribe)
  ) {
    return filteredProviders;
  }
  filteredProviders = filteredProviders
    .map(provider => {
      provider.cellData.rank = 0;
      filters.gender.forEach(gender => {
        if (provider.cellData.filterableHash.gender[0] === gender) {
          provider.cellData.rank += 1;
        }
      });
      filters.languages.forEach(filterLanguage => {
        provider.cellData.filterableHash.languages.forEach(providerLanguage => {
          if (filterLanguage === providerLanguage) {
            provider.cellData.rank += 1;
          }
        });
      });
      filters.provider_specialties.forEach(filterSpecialty => {
        provider.cellData.filterableHash.providerSpecialties.forEach(
          providerSpecialty => {
            if (filterSpecialty === providerSpecialty) {
              provider.cellData.rank += 1;
            }
          }
        );
      });
      if (filters.can_prescribe && provider.cellData.canPrescribe) {
        provider.cellData.rank += 1;
      }
      return provider;
    })
    .filter(provider => provider.cellData.rank !== 0);
  return sortProviders(filteredProviders);
};

const sortProviders = providerList =>
  providerList.sort((a, b) => {
    if (a.cellData.rank > b.cellData.rank) {
      return -1;
    } else if (a.cellData.rank < b.cellData.rank) {
      return 1;
    } else {
      return b.cellData.filterableHash.isPsychiatrist ? -1 : 0;
    }
  });

const searchProvider = (providerList, filters) => {
  if (filters.search) {
    return providerList.filter(provider =>
      provider.cellData.searchableTerm
        .toLowerCase()
        .includes(filters.search.toLowerCase())
    );
  }
  return providerList;
};

export const buildFilterString = filters => {
  let titleString;
  if (filters.hasOwnProperty("can_prescribe")) {
    const rx = filters.can_prescribe ? "rx" : "";
    const gender = filters.gender.length
      ? filters.gender.length > 1
        ? `${filters.gender[0].toLowerCase()}, ${filters.gender[1].toLowerCase()}`
        : `${filters.gender[0].toLowerCase()}`
      : "";
    const languages = filters.languages.length
      ? filters.languages.length > 1
        ? `${filters.languages.length} languages`
        : `${filters.languages.length} language`
      : "";
    const specialties = filters.provider_specialties.length
      ? filters.provider_specialties.length > 1
        ? `${filters.provider_specialties.length} specialties`
        : `${filters.provider_specialties.length} specialty`
      : "";
    titleString = [rx, gender, languages, specialties].reduce(
      (result, particle) =>
        particle
          ? result
            ? `${result}, ${particle}`
            : result + particle
          : result
    );
  }
  return {
    type: "text",
    title: titleString ? `Filters: ${titleString}` : "",
    action: { value: "ConsultationBhNewProviderFilter", type: "modal_screen" },
    name: "filterString"
  };
};

export const buildProviderList = (
  providerList,
  providerFilters,
  previousProviders = []
) => {
  const filteredProviders = filterProviders(
    searchProvider(providerList, providerFilters),
    providerFilters,
    previousProviders
  );
  return buildProviders(filteredProviders);
};
